import type {
  DatalayerProduct,
  DeliveryAddress,
  Order,
  PaymentMethod,
  Service,
  Shippings,
  SummaryData,
  CouponData
} from 'newCheckout/pages/Success/type'

import { getCartType, getShippingType } from 'frontendCheckout/tracker/utils'

import { pushDataObject } from '../../data-layer'
import { getPurchaseItems } from './utils'

export type PushPurchaseProps = {
  order: Order
  dataLayerProducts: DatalayerProduct[]
  shippings: Shippings
  services: Service[]
  address: DeliveryAddress
  paymentMethod: PaymentMethod
  summaryData: SummaryData
  coupon: CouponData
}

export const pushPurchase = (props: PushPurchaseProps) => {
  const {
    order,
    dataLayerProducts,
    shippings,
    services,
    address,
    paymentMethod,
    summaryData,
    coupon
  } = props

  const dataLayerItems = getPurchaseItems({
    address,
    dataLayerProducts,
    shippings,
    services
  })

  const hasInstallments =
    paymentMethod.type === 'credit_card' || paymentMethod.type === 'token'

  const shopNameItems = dataLayerProducts.map(item => item.shopName)
  const cartType = getCartType(shopNameItems)

  const shippingTypeItems = shippings.map(shipping => shipping.type)
  const shippingType = getShippingType(shippingTypeItems)

  const dataLayerObject = {
    _clear: true,
    event: 'purchase',
    items: dataLayerItems,
    coupon: {
      name: coupon?.name
    },
    transaction: {
      id: order._id,
      value: summaryData.subtotal + summaryData.totalServices,
      discount: order?.discount,
      payment: {
        method: paymentMethod.type,
        installments: hasInstallments
          ? paymentMethod.amount_installment
          : undefined
      }
    },
    shipping: {
      price: summaryData?.freight,
      type: shippingType
    },
    cart: {
      type: cartType
    }
  }

  pushDataObject(dataLayerObject)
}
